import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get, QueryStringManager } from "@green24/npm-javascript-utils";
import BoxTerminal from "../../../components/shared/BoxTerminal";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import Keyboard from "../../../components/Keyboard/Keyboard";
import { E_Keyboard_Type } from "../../../models/constants/Enums_Keyboard";
import Interpret from "../../../components/shared/Localization/Interpret";
import { sessionServices } from "../../../services/session-services";
import { route } from "preact-router";
import { E_Route } from "../../../models/constants/Enum_Routes";
import { E_RentWizard_Section } from "../../../models/constants/Enums_RentWizard";
import { AppUtils } from "../../../utils/AppUtils";
import { ErrorUtils } from "../../../utils/ErrorUtils";
import MessageModal from "../../../components/shared/Modal/MessageModal";

class RentWizardPinVerification extends Component {
	constructor() {
		super();

		let pin = '';

		if(AppUtils.isDev) {
			pin = new QueryStringManager(window.location.search).get("pin") || '';
		}

		this.state = {
			pin,
			//pending state when cancelling the session
			cancelling: false,
		}
	}

	render({className, style}, {pin, cancelling}) {
		return (
			<section className={combineClasses("rent-wizard-pin-verification", className)} style={style}>
				<BoxTerminal
					title={"pin.verification.title"}
					subtitle={"pin.verification.subtitle"}
					contentHeaderTitle={"pin.enter"}
					contentHeaderSlot={
						<div className={"input-value"}>
							<span>{Array(pin.length).fill('*').join('') || '‎'}</span>
							<hr/>
						</div>
					}
					contentLeftSlot={
						<>
							<p>
								<Interpret id={"pin.verification.repeat.hint"}/>
							</p>

							<ButtonsConstructor buttons={[
								{
									className: "cancel-session-button",
									text: "back",
									disabled: cancelling,
									spinner: cancelling,
									action: () => this._cancel(),
								}
							]}/>
						</>
					}
					contentRightSlot={
						<ButtonsConstructor buttons={[
							{
								className: "ok-button",
								text: "ok",
								disabled: (AppUtils.simulateWizardSessionCreation ? false : `${pin}`.length < 6) || cancelling,
								action: () => this._verifyPin(),
							}
						]}/>
					}
					contentSlot={
						<Keyboard
							view={E_Keyboard_Type.NUMERIC}
							valueDisplay={false}
							block={true}
							value={pin}
							onModify={v => this.setState({pin: pin + v})}
						/>
					}
				/>
			</section>
		);
	}

	_verifyPin() {
		const {session} = this.props;
		const {pin} = this.state;
		const sessionPin = get(session, "pin");

		if(sessionPin == pin || AppUtils.simulateWizardSessionCreation) {
			route(E_Route.RENT_WIZARD(E_RentWizard_Section.PAYMENT));
		}
	}

	_cancel() {
		const {session, onSessionCancelled} = this.props;

		this.setState({cancelling: true});

		sessionServices.deleteItem(session.id).then(() => {
			onSessionCancelled();

			route(E_Route.RENT_WIZARD(E_RentWizard_Section.CONTACT));
		}, (res) => {
			//TBD: More specific error?
			let error = ErrorUtils.getErrorFromResponse(res);

			window.modal.open(
				<MessageModal
					icon={error.icon}
					title={error.title}
					titleTranslated={error.titleTranslated}
				/>,
				{
					accent: "error",
				},
			);
		})
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			session: PropTypes.object,

			onSessionCancelled: PropTypes.func,
		}
	}

	static get stateTypes() {
		return {
			pin: PropTypes.string,
			cancelling: PropTypes.bool,
		}
	}
}

export default RentWizardPinVerification;
